import React from "react";
import Header from "./Header";
import LineBreak from "./LineBreak";
import TextInput from "./TextInput";
import SingleSelectInput from "./SingleSelectInput";
import Paragraph from "./Paragraph";
import CheckBoxInput from "./CheckBoxInput";
import DateTimeInput from "./DateTimeInput";
import DateInput from "./DateInput";
import TimeInput from "./TimeInput";
import FileUploadInput from "./FileUploadInput";
import MessageAcknowledgmentButton from "./MessageAcknowledgmentButton";
import YesNoInput from "./YesNoInput";
import TemperatureInput from "./TemperatureInput";
import SignatureInput from "./SignatureInput";
import RatingInput from "./RatingInput";
import Formula from "./Formula";
import Metadata from "./Metadata";
import EmployeeSalesData from "./EmployeeSalesData";
import MultiSelectInput from "./MultiSelectInput";

const getElementToRender = (
  settings,
  initialValue,
  onChange,
  //onSaveDraft = internalValue => {},
  formValues,
  formScores = []
) => {
  if (settings === undefined) {
    console.error("No Element Settings Found");
  }

  const handleOnChange = (id, value, extension) => {
    let scores = [];
    let element;
    if (
      settings.formElement === "YesNoInput" ||
      settings.formElementDisplayName === "Number Input"
    ) {
      element = settings;

      let actualScore = 0;
      let maxScore = 0;
      let formulaId = "";
      //console.log('element: ', element);
      if (element.score && Array.isArray(element.score)) {
        if (element.formElement === "YesNoInput") {
          element.score?.map((t) => {
            const yesScore = parseFloat(t?.score?.YesScore ?? 0);
            const noScore = parseFloat(t?.score?.NoScore ?? 0);

            formulaId = t.formulaId;
            actualScore = value ? yesScore : noScore;
            maxScore = Math.max(yesScore, noScore);
          });
        } else if (element.formElementDisplayName === "Number Input") {
          element.score?.map((t) => {
            formulaId = t.formulaId;
            if (t.score.NumberInputBasedOnEnteredValue) {
              actualScore = parseFloat(value);
              maxScore = parseFloat(value);
            } else {
              actualScore = parseFloat(t.score.NumberInput);
              maxScore = parseFloat(t.score.NumberInput);
            }
          });
        }
      }

      scores.push({
        formulaId: formulaId,
        maxScore: maxScore,
        actualScore: actualScore,
      });
    }

    onChange(id, value, extension, scores, element);
  };

  const commonProps = {
    onChange: handleOnChange,
    //onSaveDraft: onSaveDraft,
    initialValue: initialValue,
    key: settings.id,
    formValues: formValues,
    formScores: formScores,
  };

  switch (settings && settings.formElement) {
    case "Header":
      return <Header {...settings} {...commonProps} />;
    case "LineBreak":
      return <LineBreak {...settings} {...commonProps} />;
    case "TextInput":
      return <TextInput {...settings} {...commonProps} />;
    case "SingleSelectInput":
      return <SingleSelectInput {...settings} {...commonProps} />;
    case "MultiSelectInput":
      return <MultiSelectInput {...settings} {...commonProps} />;
    case "Paragraph":
      return <Paragraph {...settings} {...commonProps} />;
    case "CheckBox":
      return <CheckBoxInput {...settings} {...commonProps} />;
    case "DateTimeInput":
      return <DateTimeInput {...settings} {...commonProps} />;
    case "DateInput":
      return <DateInput {...settings} {...commonProps} />;
    case "TimeInput":
      return <TimeInput {...settings} {...commonProps} />;
    case "FileUploadInput":
      return <FileUploadInput {...settings} {...commonProps} />;
    case "MessageAcknowledgmentButton":
      return <MessageAcknowledgmentButton {...settings} {...commonProps} />;
    case "YesNoInput":
      return <YesNoInput {...settings} {...commonProps} />;
    case "TemperatureInput":
      return <TemperatureInput {...settings} {...commonProps} />;
    case "SignatureInput":
      return <SignatureInput {...settings} {...commonProps} />;
    case "RatingInput":
      return <RatingInput {...settings} {...commonProps} />;
    case "Formula":
      return <Formula {...settings} {...commonProps} />;
    case "EmployeeSalesData":
      return <EmployeeSalesData {...settings} {...commonProps} />;
    case "Metadata":
      return <Metadata {...settings} {...commonProps} />;
    default:
      console.log("Missing Element Definition", settings.formElement);
      return null;
  }
};

export { getElementToRender };
